import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import TextareaAutosize from 'vue-textarea-autosize'
import VModal from 'vue-js-modal'
import VueWordCloud from 'vuewordcloud'
import VueCookies from 'vue-cookies'
import JsonCSV from 'vue-json-csv'

Vue.use(TextareaAutosize)
Vue.use(VModal)
Vue.component(VueWordCloud.name, VueWordCloud)
Vue.use(VueCookies)
Vue.component('downloadCsv', JsonCSV)
Vue.use(require('vue-moment'))

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
